const STORAGE = {
  token: 'ccnt_prtcl_tkn',
  country: 'ccnt_prtcl_cntry',
  language: 'ccnt_prtcl_lngg',
  referrer: 'ccnt_prtcl_ref'
}

export default STORAGE
